import {Image} from 'react-native';
export default Image;
